<template>
  <div v-if="show" :style="{ width, height }" :id="chartsId"></div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { PieChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import { TitleComponent, TooltipComponent, LegendComponent, DatasetComponent, TransformComponent } from 'echarts/components';
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  DatasetComponent,
  LegendComponent,
  TransformComponent,
  PieChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
]);

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    title: {
      type: String,
      default: ''
    },
    chartsId: {
      type: String,
      default: 'charts'
    },
    data: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    myChart: ''
  }),
  mounted() {
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  watch: {
    data: {
      handler(data) {
        setTimeout(() => {
          if (data.length && this.show) this.initCharts(data);
        }, 200);
      },
      immediate: true
    },
    show(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initCharts(this.data);
          }, 200);
        });
      }
    }
  },
  methods: {
    resize() {
      if (!this.myChart) return;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.myChart.resize();
      }, 200);
    },
    initCharts(data) {
      var mychartTag = echarts.getInstanceByDom(document.getElementById(this.chartsId));
      if (mychartTag == null) {
        this.myChart = echarts.init(document.getElementById(this.chartsId));
      }

      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: 0,
          right: 30,
          textStyle: {},
          itemGap: 8
        },
        series: [
          {
            name: '样品检测统计',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4
            },
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter: '{b}\n{c} ({d}%)',
              fontSize: 16,
              fontWeight: 'bold'
            },
            labelLine: {
              show: true,
              length: 6,
              length2: 14
            },
            data: data.map(item => {
              return {
                value: item.cnt,
                name: item.sampleType == 0 ? '安全工器具' : '施工工器具'
              };
            })
          }
        ]
      };
      this.myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped></style>
